/**
 * 我采购的竞价列表地址
 */
export const TRADITION_AUCTION_PURCHASE_LIST_PAGE_PATH =
  '/auction/tradition/list/purchase'
